const React = require('react');

const Item = require('./Item.jsx');
const _ItemContainer = require('../common/ItemContainer.jsx');

class ItemContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleComponentType = this.handleComponentType.bind(this);
    }

    handleComponentType(type) {
        switch (type) {
            case 'itemCustomMeta':
                return Item.CustomMeta.Component;
            case 'itemNotes':
                return Item.Notes.Component;
            case 'itemOrder':
                return Item.Order.Component;
            case 'itemPrice':
                return Item.Price.Component;
            case 'itemPrivateNotes':
                return Item.PrivateNotes.Component;
            default:
                return null;
        }
    }

    render() {
        const data = this.props.data || {};
        return (
            <_ItemContainer.List
                {...this.props}
                items={data.Inventory}
                onComponentType={this.handleComponentType} />
        );
    }
}

module.exports = {
    List: ItemContainer,
    TypeConfig: _ItemContainer.TypeConfig
};